import { rp } from "@/lib/format";

/**
 * Promo chips shared — dipakai ProductGridCard (grid) & ProductCard (feed).
 * Satu sumber desain: badge discount gacor, urgency chip, hemat chip.
 */

/** Badge discount gradient merah-oranye + shine & glow (CSS: .discount-badge) */
export function DiscountBadge({ persen, className = "" }) {
  if (!persen || persen <= 0) return null;
  return (
    <span className={`discount-badge px-2.5 py-1 rounded-full text-[9px] font-bold tracking-[0.12em] border border-white/60 ${className}`}>
      −{persen}%
    </span>
  );
}

/** Chip urgency: HOT DEAL menang atas PO terbatas. Return null kalau tidak ada. */
export function UrgencyChip({ soldOut, diskon = 0, stockStatus, className = "" }) {
  if (soldOut) return null;
  // Jastip = semua pada dasarnya PO → tidak usah pamer tag PO. Hanya HOT DEAL yang layak tampil.
  const label = diskon >= 30 ? "🔥 HOT DEAL" : null;
  if (!label) return null;
  return (
    <span className={`px-2.5 py-1 rounded-full text-[9px] font-bold tracking-[0.12em] border border-white/60 bg-white/85 text-[#e0432b] backdrop-blur-sm ${className}`}>
      {label}
    </span>
  );
}

/** Chip HEMAT rupiah — hijau mint, lebih menggoda dari persen doang */
export function HematChip({ hargaCoret, hargaJual, className = "" }) {
  const hemat = hargaCoret && hargaCoret > hargaJual ? hargaCoret - hargaJual : 0;
  if (!hemat) return null;
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-[9px] font-bold tracking-[0.08em] bg-mint-100 text-emerald-700 dark:bg-emerald-400/15 dark:text-emerald-300 border border-emerald-500/20 ${className}`}>
      HEMAT {rp(hemat)}
    </span>
  );
}
